import { render, staticRenderFns } from "./ResetMain.vue?vue&type=template&id=5117e1b7&scoped=true"
import script from "./ResetMain.vue?vue&type=script&lang=js"
export * from "./ResetMain.vue?vue&type=script&lang=js"
import style0 from "./ResetMain.vue?vue&type=style&index=0&id=5117e1b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117e1b7",
  null
  
)

export default component.exports